module.exports = __webpack_public_path__ + "672126a70642574b2a234ecc37e8102a.MP3";